import { TableCell, Box, Typography, Chip } from "@mui/material";
import { formatCurrency } from "@covertree/utils";

interface Props {
  title: string;
  isRecommended?: boolean;
  monthlyPrice: number;
  yearlyPrice: number;
  dataTestId?: string;
}

export function CompareOfferTableHeaderCell({
  title,
  isRecommended,
  monthlyPrice,
  yearlyPrice,
  dataTestId,
}: Props) {
  return (
    <TableCell
      sx={(theme) =>
        isRecommended
          ? {
              backgroundColor: `${theme.palette.info.main}0D`,
              borderRadius: theme.spacing(1.5, 1.5, 0, 0),
            }
          : {}
      }>
      <Box
        sx={(theme) => ({
          marginBottom: theme.spacing(1),
          height: theme.spacing(3),
          display: "flex",
          justifyContent: "center",
        })}>
        {isRecommended && (
          <Chip color="secondary" label="Recommended" size="small" />
        )}
      </Box>
      <Typography data-testid={dataTestId}>{title}</Typography>
      <Box display="flex" flexDirection="row" alignItems="flex-end" mb={0.5}>
        <Typography>{formatCurrency(monthlyPrice, 2)}</Typography>
        <Typography variant="body2">/mo</Typography>
      </Box>
      <Box display="flex" flexDirection="row" alignItems="flex-end">
        <Typography variant="subtitle1" color="info.main">
          ({formatCurrency(yearlyPrice, 2)}/year)
        </Typography>
      </Box>
    </TableCell>
  );
}
